module.exports = __webpack_public_path__ + "img/tobottom.7ff963f4.gif";